import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Keep the floating greeting off dense reading/form sections.
// Those sections offer an inline chat control instead.
export const useChatSafeArea = () => {
  const { pathname } = useLocation();
  const [insideSafeArea, setInsideSafeArea] = useState(false);

  useEffect(() => {
    const mobile = window.matchMedia("(max-width: 639px)");
    const compactDesktop = window.matchMedia("(max-width: 1919px)");
    let observer;
    const observe = () => {
      observer?.disconnect();
      setInsideSafeArea(false);
      if (!mobile.matches && !compactDesktop.matches) return;
      const visible = new Set();
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setInsideSafeArea(visible.size > 0);
      }, { rootMargin: "-68px 0px 0px 0px" });
      document.querySelectorAll("[data-chat-safe-area]").forEach((section) => {
        const protect = section.dataset.chatSafeArea === "wide" ? compactDesktop.matches : mobile.matches;
        if (protect) observer.observe(section);
      });
    };
    observe();
    mobile.addEventListener("change", observe);
    compactDesktop.addEventListener("change", observe);
    return () => {
      observer?.disconnect();
      mobile.removeEventListener("change", observe);
      compactDesktop.removeEventListener("change", observe);
    };
  }, [pathname]);

  return insideSafeArea;
};